import { render, staticRenderFns } from "./ColdClientImportModal.vue?vue&type=template&id=5a60b3f2&scoped=true&"
import script from "./ColdClientImportModal.vue?vue&type=script&lang=js&"
export * from "./ColdClientImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ColdClientImportModal.vue?vue&type=style&index=0&id=5a60b3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60b3f2",
  null
  
)

export default component.exports